export default {"src":"/_next/static/media/chevronLeft.aeac8e09.svg","height":12,"width":7,"blurWidth":0,"blurHeight":0};